// Private helper function to escape search terms (allows search terms
// to contain regex meta characters without interpreting them as such)
function escapeRegExp(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}

/**
 * Utility function that replace all occurrences of strings in a text
 * given a set of search terms and corresponding replacement values
 *
 * @param txt The text you want the substitutions to happen in
 * @param dict A key/val object to hold the search terms and corresponding replacement values
 * @param caseSensitive false (default): match strings regardless of their case, true: only replace strings with case matching the search term
 */
export const replaceText = (
  txt: string,
  dict: { [search: string]: string },
  caseSensitive = false,
) => {
  const reSearchStr = Object.keys(dict).map(escapeRegExp).join('|')
  const reFlag = caseSensitive ? 'g' : 'gi'
  const re = new RegExp(reSearchStr, reFlag)
  if (!caseSensitive) {
    return txt.replace(re, (matched: string) => dict[matched.toLowerCase()] || matched)
  }
  return txt.replace(re, (matched: string) => dict[matched] || matched)
}
